export class ListReport {
    locale?: string;
    localeString?: string;
    reportCode?: string;
    reportOutputType?: string;
    parameters?: string[];
    reportData?: any;

    //helper
}

export class ReportOutputType {
    constructor(
        public readonly mime: string,
        public readonly type: string
    ) {
    }
}

export class ReportOutputTypes {
    public static readonly PDF: ReportOutputType = new ReportOutputType('application/pdf', 'PDF');
    public static readonly CSV: ReportOutputType = new ReportOutputType('text/csv', 'CSV');
    public static readonly JSON: ReportOutputType = new ReportOutputType('application/json', 'JSON');
    public static readonly XLS: ReportOutputType = new ReportOutputType('application/vnd.ms-excel', 'XLS');
    public static readonly XLSX: ReportOutputType = new ReportOutputType('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'XLSX');
    public static readonly ODS: ReportOutputType = new ReportOutputType('application/vnd.oasis.opendocument.spreadsheet', 'ODS');
    public static readonly DOCX: ReportOutputType = new ReportOutputType('application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'DOCX');
    public static readonly ODT: ReportOutputType = new ReportOutputType('application/vnd.oasis.opendocument.text', 'ODT');
    public static readonly RTF: ReportOutputType = new ReportOutputType('application/rtf', 'RTF');
    public static readonly XML: ReportOutputType = new ReportOutputType('text/xml', 'XML');
    public static readonly HTML: ReportOutputType = new ReportOutputType('text/html', 'HTML');
}